import Cookies from "js-cookie"
const reduceSideBarCookie = "reduceSideBarCookie"

class SidebarController {
  constructor() {
    this.load()
  }

  load() {
    $(".js-toggleSidebarButton").on("click", function () {
      $(".js-toggleSidebar").toggleClass("is-reduce")
      if (Cookies.get(reduceSideBarCookie)) {
        Cookies.remove(reduceSideBarCookie)
      } else {
        Cookies.set(reduceSideBarCookie, "yes", {
          // 7 days expires
          expires: 7,
        })
      }
    })
  }
}

export { SidebarController }
